// crypto.randomUUID sólo existe en contextos seguros (HTTPS, localhost). En desarrollo la app se
// sirve en http://localhost.com, que no lo es, y @twnel/utils-js v2 lo usa para generar los ids
// de los mensajes. getRandomValues sí está disponible: se usa para generar un UUID v4.
const randomUUID = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  /* eslint-disable no-bitwise */
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // versión 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variante RFC 4122
  /* eslint-enable no-bitwise */
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

if (typeof crypto !== 'undefined' && typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = randomUUID;
}

export default randomUUID;
